import useSWR from "swr";

export const useFetchSortedPublications = () => {
  const url = `${process.env.REACT_APP_API_URL}/fetch-publication`;
  const { data, error } = useSWR(url);
  return {
    fetchedPublications: data,
    isLoading: !error && !data,
    isError: error,
  };
};

const usePublication = () => {
  const url = `${process.env.REACT_APP_API_URL}/about/publications`;
  const { data, error } = useSWR(url);
  return {
    publications: data,
    isLoading: !error && !data,
    isError: error,
  };
};

const usePublicationById = (id) => {
  const url = `${process.env.REACT_APP_API_URL}/about/publications/${id}`;
  const { data, error } = useSWR(url);
  return {
    publication: data,
    isLoading: !error && !data,
    isError: error,
  };
};

export { usePublication, usePublicationById };
